import { PatchShapeData } from "../Data/PatchShapeData";

export enum PatchShapeType {
    SQUARE_SMALL,
    SQUARE_LARGE,
    LINE_SMALL,
    LINE_LARGE,
    ELBOW,
    NUM_ELEMENTS,
}

export class PatchShapes {
    private static _data: ReadonlyArray<PatchShapeData> = PatchShapes.create();

    public static get data(): ReadonlyArray<PatchShapeData> {
        return PatchShapes._data;
    }

    private static create(): PatchShapeData[] {
        const data: PatchShapeData[] = new Array<PatchShapeData>(PatchShapeType.NUM_ELEMENTS);

        data[PatchShapeType.SQUARE_SMALL] = new PatchShapeData(
            [
                [ true ],
            ],
            new PIXI.Polygon(
                new PIXI.Point(0, 0),
                new PIXI.Point(1, 0),
                new PIXI.Point(1, 1),
                new PIXI.Point(0, 1),
            ),
        );
        data[PatchShapeType.SQUARE_LARGE] = new PatchShapeData(
            [
                [ true, true ],
                [ true, true ],
            ],
            new PIXI.Polygon(
                new PIXI.Point(0, 0),
                new PIXI.Point(2, 0),
                new PIXI.Point(2, 2),
                new PIXI.Point(0, 2),
            ),
        );
        data[PatchShapeType.LINE_SMALL] = new PatchShapeData(
            [
                [ true, true ],
            ],
            new PIXI.Polygon(
                new PIXI.Point(0, 0),
                new PIXI.Point(2, 0),
                new PIXI.Point(2, 1),
                new PIXI.Point(0, 1),
            ),
        );
        data[PatchShapeType.LINE_LARGE] = new PatchShapeData(
            [
                [ true, true, true ],
            ],
            new PIXI.Polygon(
                new PIXI.Point(0, 0),
                new PIXI.Point(3, 0),
                new PIXI.Point(3, 1),
                new PIXI.Point(0, 1),
            ),
        );
        data[PatchShapeType.ELBOW] = new PatchShapeData(
            [
                [ true, false ],
                [ true, true ],
            ],
            new PIXI.Polygon(
                new PIXI.Point(0, 0),
                new PIXI.Point(1, 0),
                new PIXI.Point(1, 1),
                new PIXI.Point(2, 1),
                new PIXI.Point(2, 2),
                new PIXI.Point(0, 2),
            ),
        );

        return data;
    }
}
